import React from 'react'
import { TaskViewMode } from '@ztechapps/task.common'
import { Icon } from '@ztechapps/webui.util'
import { useTaskFilterBarContext } from '../TaskFilterBar/Context'
import styles from './TaskViewSwitcher.module.scss'

type ViewTab = {
  mode: TaskViewMode
  label: string
  icon: string
}

const VIEW_TABS: ViewTab[] = [
  { mode: TaskViewMode.List, label: 'List', icon: 'list' },
  { mode: TaskViewMode.Board, label: 'Board', icon: 'columns' },
  { mode: TaskViewMode.Calendar, label: 'Calendar', icon: 'calendar' },
]

type TaskViewSwitcherProps = {
  viewMode?: TaskViewMode
  setViewMode?: (mode: TaskViewMode) => void
}

export const TaskViewSwitcher = ({
  viewMode: viewModeProp,
  setViewMode: setViewModeProp,
}: TaskViewSwitcherProps = {}) => {
  const { viewMode: viewModeContext, setViewMode: setViewModeContext } = useTaskFilterBarContext()
  const resolvedViewMode = viewModeProp ?? viewModeContext
  const resolvedSetViewMode = setViewModeProp ?? setViewModeContext

  return (
    <div className="d-inline-flex border rounded-2 overflow-hidden">
      {VIEW_TABS.map((tab) => (
        <button
          key={tab.mode}
          type="button"
          className={`${styles.tab} py-1 px-3 border-0 fw-medium text-nowrap ${resolvedViewMode === tab.mode ? styles.tabActive : 'bg-body text-body'}`}
          onClick={() => resolvedSetViewMode?.(tab.mode)}
        >
          <Icon name={tab.icon} className="me-1" />
          {tab.label}
        </button>
      ))}
    </div>
  )
}
